<template>
    <div v-show="isOpen" class="tab-content">
        <div class="tab-content__block">
            <slot/>
        </div>
    </div>
</template>

<script>
    export default {
        name: "tabComponent",
        props: {
            title: {
                type: String,
            },
        },
        data() {
            return {
                isOpen: false
            }
        },
        watch: {
            '$parent.active':{
                handler: function (newValue, oldValue) {
                    this.isOpen = newValue === this.title;
                },
                immediate:true,
            }
        },
        created(){
            this.$parent.addTab(this)
        }
    }
</script>

<style lang="scss" scoped>
    .tab-content{

    }
</style>